import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "ce-243-244-class"
    }}>{`Class changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Request\\Query\\Match`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\SearchAdapter\\Mapper::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Elasticsearch5\\SearchAdapter\\Mapper::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Backend\\Model\\Menu\\Filter\\Iterator::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\FunctionalTestingFramework\\Util\\Iterator\\AbstractIterator::isValid`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\FunctionalTestingFramework\\Util\\Iterator\\AbstractIterator::rewind`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\FunctionalTestingFramework\\Util\\Iterator\\AbstractIterator::next`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\FunctionalTestingFramework\\Util\\Iterator\\AbstractIterator::valid`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\FunctionalTestingFramework\\Util\\Iterator\\AbstractIterator::count`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\FunctionalTestingFramework\\Util\\Iterator\\File::isValid`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Test\\Integrity\\PublicCodeTest::publicPHPTypesDataProvider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogInventory\\Model\\StockStateException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Request\\Query\\MatchQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Payment::setCustomAttribute`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Block\\Adminhtml\\Order\\View\\Tab\\Creditmemos::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Block\\Adminhtml\\Order\\View\\Tab\\Invoices::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\ResourceModel\\Customer::findSessionCutOff`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\ResourceModel\\Customer::updateSessionCutOff`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Config\\ConfigOptionsListConstants::CONFIG`}{`_`}{`PATH`}{`_`}{`WEBAPI`}{`_`}{`SYNC`}{`_`}{`DEFAULT`}{`_`}{`INPUT`}{`_`}{`ARRAY`}{`_`}{`SIZE`}{`_`}{`LIMIT`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Config\\ConfigOptionsListConstants::CONFIG`}{`_`}{`PATH`}{`_`}{`WEBAPI`}{`_`}{`ASYNC`}{`_`}{`DEFAULT`}{`_`}{`INPUT`}{`_`}{`ARRAY`}{`_`}{`SIZE`}{`_`}{`LIMIT`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-243-244-database"
    }}>{`Database changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`jwt`}{`_`}{`auth`}{`_`}{`revoked`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`test`}{`_`}{`table`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`dependent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`customer`}{`_`}{`entity/session`}{`_`}{`cutoff`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`customer`}{`_`}{`visitor/created`}{`_`}{`at`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`magento`}{`_`}{`operation/started`}{`_`}{`at`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`dependent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whitelist do not have table dependent declared in db`}{`_`}{`schema.xml`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-243-244-system"
    }}>{`System changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/validation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/validation/input`}{`_`}{`limit`}{`_`}{`enabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/validation/complex`}{`_`}{`array`}{`_`}{`limit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/validation/maximum`}{`_`}{`page`}{`_`}{`size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/validation/default`}{`_`}{`page`}{`_`}{`size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`recaptcha`}{`_`}{`frontend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A section-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`recaptcha`}{`_`}{`frontend/type`}{`_`}{`for`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`recaptcha`}{`_`}{`frontend/type`}{`_`}{`for/coupon`}{`_`}{`code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cataloginventory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A section-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cataloginventory/options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cataloginventory/options/enable`}{`_`}{`inventory`}{`_`}{`check`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/jwtauth`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/jwtauth/jwt`}{`_`}{`alg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/jwtauth/jwe`}{`_`}{`alg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/jwtauth/customer`}{`_`}{`expiration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/jwtauth/admin`}{`_`}{`expiration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`oauth/consumer/enable`}{`_`}{`integration`}{`_`}{`as`}{`_`}{`bearer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/graphql`}{`_`}{`validation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/graphql`}{`_`}{`validation/input`}{`_`}{`limit`}{`_`}{`enabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/graphql`}{`_`}{`validation/maximum`}{`_`}{`page`}{`_`}{`size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-243-244-xsd"
    }}>{`Xsd changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`app/code/module-webapi/etc/webapi`}{`_`}{`base.xsd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A schema declaration was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`app/code/module-webapi-async/etc/webapi`}{`_`}{`async.xsd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A schema declaration was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`app/code/module-webapi/etc/webapi`}{`_`}{`base.xsd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A schema declaration was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`app/code/module-webapi-async/etc/webapi`}{`_`}{`async.xsd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A schema declaration was added`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-243-244-class-api-membership"
    }}>{`Class API membership changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import\\AbstractSource`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Zend`}{`_`}{`Db`}{`_`}{`Select`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Wishlist\\Block\\AbstractBlock`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\DataProvider\\AbstractDataProvider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Block\\Adminhtml\\Totals`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\Validator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Backend\\App\\Action\\Plugin\\Authentication`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Session\\SessionManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Sql\\Expression`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\AbstractSimpleObjectBuilder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\UrlRewrite\\Model\\UrlRewrite::setMetadata`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\UrlRewrite\\Model\\UrlRewrite::cleanEntitiesCache`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\UrlRewrite\\Model\\ResourceModel\\UrlRewriteCollection::$storeManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PageCache\\Model\\DepersonalizeChecker::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PageCache\\Model\\Varnish\\VclGenerator::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::setStoreId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::getDisplayActualPriceType`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::getExplanationMessage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::getExplanationMessageWhatsThis`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::$scopeConfig`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::$storeManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::$escaper`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::$storeId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::XML`}{`_`}{`PATH`}{`_`}{`MSRP`}{`_`}{`ENABLED`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::XML`}{`_`}{`PATH`}{`_`}{`MSRP`}{`_`}{`DISPLAY`}{`_`}{`ACTUAL`}{`_`}{`PRICE`}{`_`}{`TYPE`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::XML`}{`_`}{`PATH`}{`_`}{`MSRP`}{`_`}{`EXPLANATION`}{`_`}{`MESSAGE`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Config::XML`}{`_`}{`PATH`}{`_`}{`MSRP`}{`_`}{`EXPLANATION`}{`_`}{`MESSAGE`}{`_`}{`WHATS`}{`_`}{`THIS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Msrp::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Msrp::$mapApplyToProductType`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Msrp::$eavAttributeFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Product\\Options::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Product\\Options::getVisibilities`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Product\\Options::$config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Model\\Product\\Options::$msrpData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\Config::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\Config::$`}{`_`}{`configCacheType`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\Config::$`}{`_`}{`configReader`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\Config::$`}{`_`}{`integrations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\Config::CACHE`}{`_`}{`ID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\IntegrationConfig::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\IntegrationConfig::$`}{`_`}{`configCacheType`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\IntegrationConfig::$`}{`_`}{`configReader`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\IntegrationConfig::$`}{`_`}{`integrations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\IntegrationConfig::CACHE`}{`_`}{`ID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogSearch\\Model\\Indexer\\Mview\\Action::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogRule\\Model\\ResourceModel\\Rule\\Collection::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogRule\\Model\\ResourceModel\\Rule\\Collection::`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogRule\\Model\\ResourceModel\\Rule\\Collection::mapAssociatedEntities`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogRule\\Model\\ResourceModel\\Rule\\Collection::addCustomerGroupFilter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogRule\\Model\\ResourceModel\\Rule\\Collection::$`}{`_`}{`associatedEntitiesMap`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogRule\\Model\\ResourceModel\\Rule\\Collection::$serializer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogRule\\Model\\ResourceModel\\Rule\\Collection::$`}{`_`}{`eventPrefix`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogRule\\Model\\ResourceModel\\Rule\\Collection::$`}{`_`}{`eventObject`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\ConstraintFactory::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\ConstraintFactory::$`}{`_`}{`objectManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\ConstraintFactory::$`}{`_`}{`instanceName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Currency::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Currency::$lists`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Locale::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Locale::$lists`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Timezone::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Timezone::$lists`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Entity\\Properties::setReadOnlyProperties`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Entity\\Properties::`}{`_`}{`hasChanges`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Entity\\Properties::$`}{`_`}{`readOnlyProperties`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Copy::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Copy::dispatchCopyFieldSetEvent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Copy::`}{`_`}{`isFieldsetInputValid`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Copy::`}{`_`}{`getFieldsetFieldValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Copy::`}{`_`}{`setFieldsetFieldValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Copy::getAttributeValueFromExtensibleDataObject`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Copy::setAttributeValueFromExtensibleDataObject`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Copy::$fieldsetConfig`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Copy::$eventManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Copy::$extensionAttributesFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\AreaList::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\AreaList::getArea`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\AreaList::$`}{`_`}{`areas`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\AreaList::$`}{`_`}{`areaInstances`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\AreaList::$`}{`_`}{`defaultAreaCode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\AreaList::$`}{`_`}{`resolverFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\AreaList::$objectManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\Data\\ProcessorFactory::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\Data\\ProcessorFactory::$`}{`_`}{`objectManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\Data\\ProcessorFactory::$`}{`_`}{`pool`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ce-243-244-interface-api-membership"
    }}>{`Interface API membership changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\AdminTokenServiceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\AuthyAuthenticateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\AuthyConfigureInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\CountryRepositoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\DuoAuthenticateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\DuoConfigureInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\EngineInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\GoogleAuthenticateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\GoogleConfigureInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\ProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\ProviderPoolInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\TfaInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\TfaSessionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\TfatActionsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\U2fKeyAuthenticateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\U2fKeyConfigReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\U2fKeyConfigureInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\UserConfigManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\UserConfigRepositoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\UserConfigRequestManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\UserConfigTokenManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\UserNotifierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Exception\\NotificationExceptionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\AdminTokenResponseInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\AuthyDeviceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\AuthyRegistrationPromptResponseInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\CountryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\CountrySearchResultsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\DuoDataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\GoogleAuthenticateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\GoogleConfigureInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\U2fWebAuthnRequestInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\UserConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TwoFactorAuth\\Api\\Data\\UserConfigSearchResultsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockClient\\Model\\SearchParameterProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockClientApi\\Api\\ClientInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockAssetApi\\Model\\Creator\\Command\\DeleteByIdInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockAssetApi\\Model\\Creator\\Command\\LoadByIdInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockAssetApi\\Model\\Creator\\Command\\SaveInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockAssetApi\\Model\\Category\\Command\\DeleteByIdInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockAssetApi\\Model\\Category\\Command\\LoadByIdInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockAssetApi\\Model\\Category\\Command\\SaveInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockAssetApi\\Model\\Asset\\Command\\DeleteByIdInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockAssetApi\\Model\\Asset\\Command\\LoadByIdInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockAssetApi\\Model\\Asset\\Command\\LoadByIdsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeStockAssetApi\\Model\\Asset\\Command\\SaveInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeImsApi\\Api\\LogInInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeImsApi\\Api\\LogOutInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Api\\Data\\ProductRenderSearchResultsInterface::getItems`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TestModuleDefaultHydrator\\Api\\Data\\ExtensionAttributeInterface::getId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TestModuleDefaultHydrator\\Api\\Data\\ExtensionAttributeInterface::ID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TestModuleDefaultHydrator\\Api\\Data\\ExtensionAttributeInterface::CUSTOMER`}{`_`}{`ID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TestModuleDefaultHydrator\\Api\\Data\\ExtensionAttributeInterface::VALUE`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      